import i18n from '../i18n';

const fieldKeys = (opts) =>
  opts.reduce((keys, item) => {
    keys.push(item.val);
    return keys;
  }, []);

const urlBaseName = window.PUBLIC_URL;
const docPath = urlBaseName + '/welcome-center-tech-docs/welcomeCenterDocs/';
export const DOC_PATH = docPath;
export const DOC_CONFIG_FOLDER = 'config/';
export const DOC_FETCH_MODE = { cache: 'no-cache' };
export const URL_BASENAME = urlBaseName;
export const PRODUCT_ID_NIMBLE = 'nimble';
export const PRODUCT_ID_DHCI = 'dHCI';
export const PRODUCT_ID_DHCI_ALLETRA6K = 'dHCI_alletra6k';
export const PRODUCT_ID_PRIMERA = 'primera';
export const PRODUCT_ID_ALLETRA = 'alletra';
export const MODEL_ALLETRAMP = 'HPE Alletra Storage MP';
export const MODEL_ALLETRAMPX10000 = 'HPE Alletra Storage MP X10000';
export const MODEL_ALLETRAMPB10000 = 'HPE Alletra Storage MP B10000';
export const PRODUCT_ID_ALLETRA9k = 'alletra9k';
export const HPE_ALLETRA_DHCI_STORAGE = 'HPE Alletra dHCI Storage';
export const PRODUCT_ID_ALLETRA6k = 'alletra6k';
export const PRODUCT_ID_ALLETRA5k = 'alletra5k';
export const PRODUCT_ID_BAAS = 'baas';
export const PRODUCT_ID_OAAS = 'oaas';
export const PRODUCT_ID_FILE = 'file';
export const PRODUCT_ID_ALLETRAFILE = 'file';
export const PRODUCT_ID_BAAS_5K_G = 'baas5k';
export const PRODUCT_ID_BAAS_6K_B = 'baas6k';
export const PRODUCT_ID_BAAS_9K_M = 'baas9k';
export const PRODUCT_ID_CLOUD = 'cloudenablement';
export const PRIMERA_CLOUD_PAGENEME = 'cloudenablement-primera';
export const NIMBLE_CLOUD_PAGENEME = 'cloudenablement-nimble';
export const dHCI_CLOUD_PAGENEME = 'cloudenablement-dHCI';
export const dHCI5k6k_CLOUD_PAGENEME = 'cloudenablement-dHCI5k6k';
export const BAAS_CLOUD_PAGENEME = 'cloudenablement-baas';
export const FILE_CLOUD_PAGENEME = 'cloudenablement-file';
export const SIMPLIVITY_CLOUD_PAGENEME = 'cloudenablement-simplivity';
export const OAAS_CLOUD_PAGENEME = 'cloudenablement-oaas';
export const SDS_CLOUD_PAGENAME = 'cloudenablement-SDS';
export const DEDICATED_PLATFORM_CLOUD_PAGENEME =
  'cloudenablement-dedicatedPlatform';
export const CLOUD_DOC_FOLDER_NAME = 'Common_docs/Cloud_Enablement';
export const DEDICATED_PLATFORM_DOC_FOLDER_NAME =
  'Common_docs/Dedicated_Platform_Enablement';
export const CLOUD_MODEL_CONFIG = 'Array.json';
export const CABEL_CONNECT = 'cableBluetooth';
export const INSTALLATION_TYPE = 'Installation Type';
export const TYPE_INSTALLATION = 'Select the installation type';
export const PAGENAME_PREINSTALLATION_BLUETOOTH = 'preAppInstallation';
export const PAGENAME_PREINSTALLATION = 'preInstallation';
export const PAGENAME_PREINSTALLATION_EXISTING = 'preInstallation-brown';
export const PAGENAME_PREINSTALLATION_NEW = 'preInstallation-green';
export const PAGENAME_PREINSTALLATION_SIMPLIVITY325 =
  'preInstallationSimplivity325';
export const PAGENAME_PREINSTALLATION_SIMPLIVITY380 =
  'preInstallationSimplivity380';
export const PAGENAME_PREINSTALLATION_SIMPLIVITY380PLUS =
  'preInstallationSimplivity380Plus';
export const PAGENAME_PREINSTALLATION_VME = 'preInstallationVME';
export const PAGENAME_PREINSTALLATION_VMWARE = 'preInstallationVMware';
export const PAGENAME_SITEREADINESS_BLUETOOTH = 'siteReadinessApp';
export const PAGENAME_SITEREADINESS = 'siteReadiness';
export const PAGENAME_CONNECTARRAY_BLUETOOTH = 'connectArrayForApp';
export const PAGENAME_CONNECTARRAY = 'connectArray';
export const PAGENAME_SETUPARRAY_BLUETOOTH = 'arraySetupForApp';
export const PAGENAME_SETUPARRAY = 'arraySetup';
export const PRODUCT_ID_PCBE = 'pcbe';
export const PRODUCT_ID_SDS = 'sds';
export const PRODUCT_ID_ALLETRAB10K = 'alletraB10k';
export const HPE_ALLETRA_DHCI = 'HPE Alletra dHCI';
export const HPE_ALL_FLASH = 'All Flash';
export const HPE_HYBRID_FLASH = 'Hybrid Flash';
export const HPE_SIMPLIVITY = 'HPE SimpliVity';
export const CONNECT_TO_VCENTER = 'ConnectToVcenter';
export const HPE_GREENLAKE_PLATFORM = 'greenlakePlatform';
export const RACK_CHECKER = 'rack';
export const RACK_SWITCHED = 'rackSwitched';
export const RACK_SWITCHED_NOCABLETRAY = 'rackSwitchedNoCableTray';
export const CABEL_CHECKER = 'cable';
export const CABLE_SWITCHED = 'cableSwitched';
export const UNBOX_CHECKER = 'unbox';
export const UNBOX_FACTORY = 'unboxFactory';
export const UNBOX_FIELD = 'unboxField';
export const PAGENAME_INSTALLBRACKETS_SIMPLIVITY325 = 'installBrackets';
export const PAGENAME_INSTALLBRACKETS_SIMPLIVITY380 =
  'installBracketsSimplivity380';
export const PAGENAME_INSTALLBRACKETS_SIMPLIVITY380PLUS =
  'installBracketsSimplivity380Plus';
export const PAGENAME_INSTALLSERVER_SIMPLIVITY325 = 'installServer';
export const PAGENAME_INSTALLSERVER_SIMPLIVITY380 =
  'installServerSimplivity380';
export const PAGENAME_INSTALLSERVER_SIMPLIVITY380PLUS =
  'installServerSimplivity380Plus';
export const PAGENAME_POWERON_SIMPLIVITY325 = 'powerOnSimplivity';
export const PAGENAME_POWERON_SIMPLIVITY380 = 'powerOnSimplivity380';
export const PAGENAME_POWERON_SIMPLIVITY380PLUS = 'powerOnSimplivity380Plus';
export const PAGENAME_CONFIGUREILO_SIMPLIVITY325 = 'ConfigureIloPort';
export const PAGENAME_CONFIGUREILO_SIMPLIVITY380 =
  'ConfigureIloPortSimplivity380';
export const PAGENAME_CONNECTTOILO_SIMPLIVITY325 = 'ConnectToIlo';
export const PAGENAME_CONNECTTOILO_SIMPLIVITY380 = 'ConnectToIloSimplivity380';
export const PAGENAME_CABLE_SIMPLIVITY325 = 'cableSimplivity';
export const PAGENAME_CABLE_SIMPLIVITY380 = 'cableSimplivity380';
export const PAGENAME_CABLE_SIMPLIVITY380PLUS = 'cableSimplivity380Plus';
export const PAGENAME_CONFIGSWITCH = 'configSwitch';
export const PAGENAME_CONFIGSWITCH_EXISTENV = 'configSwitchExistEnv';
export const PAGENAME_PREPARE_ENV = 'prepareEnv';
export const PAGENAME_PREPARE_ENV_EXISTENV = 'prepareEnvExistEnv';
export const PAGENAME_ARRAY_DISCOVERY = 'arrayDiscovery';
export const PAGENAME_ARRAY_DISCOVERY_EXISTENV = 'arrayDiscoveryExistEnv';
export const PAGENAME_SETUPARRAY_EXISTENV = 'arraySetupExistEnv';
export const PAGENAME_VALIDATE_ARRAY = 'arrayValidation';
export const PAGENAME_PREINSTALLATION_SIMPLIVITY325_GEN11 =
  'preInstallationSimplivity325Gen11';
export const PAGENAME_PREINSTALLATION_SIMPLIVITY380_GEN11 =
  'preInstallationSimplivity380Gen11';
export const PAGENAME_INSTALLBRACKETS_SIMPLIVITY325_GEN11 =
  'installBracketsSimplivity325Gen11';
export const PAGENAME_INSTALLBRACKETS_SIMPLIVITY380_GEN11 =
  'installBracketsSimplivity380Gen11';
export const PAGENAME_INSTALLSERVER_SIMPLIVITY325_GEN11 =
  'installServerSimplivity325Gen11';
export const PAGENAME_INSTALLSERVER_SIMPLIVITY380_GEN11 =
  'installServerSimplivity380Gen11';
export const PAGENAME_POWERON_SIMPLIVITY325_GEN11 = 'powerOnSimplivity325Gen11';
export const PAGENAME_POWERON_SIMPLIVITY380_GEN11 = 'powerOnSimplivity380Gen11';
export const PAGENAME_CONFIGUREILO_SIMPLIVITY325_GEN11 =
  'ConfigureIloPortSimplivity325Gen11';
export const PAGENAME_CONFIGUREILO_SIMPLIVITY380_GEN11 =
  'ConfigureIloPortSimplivity380Gen11';
export const PAGENAME_CONNECTTOILO_SIMPLIVITY325_GEN11 =
  'ConnectToIloSimplivity325Gen11';
export const PAGENAME_CONNECTTOILO_SIMPLIVITY380_GEN11 =
  'ConnectToIloSimplivity380Gen11';
export const PAGENAME_CABLE_SIMPLIVITY325_GEN11 = 'cableSimplivity325Gen11';
export const PAGENAME_CABLE_SIMPLIVITY380_GEN11 = 'cableSimplivity380Gen11';
export const PRODUCT_NAMES = new Map([
  [PRODUCT_ID_NIMBLE, i18n.t('nimbleStorageArray')],
  [PRODUCT_ID_DHCI, i18n.t('nimbleStoragedHCI')],
  [PRODUCT_ID_PRIMERA, i18n.t('primeraStorage')],
  [PRODUCT_ID_ALLETRA, i18n.t('hpeAlletra')],
  [PRODUCT_ID_BAAS, i18n.t('baas')],
  [PRODUCT_ID_OAAS, i18n.t('oaas')],
  [PRODUCT_ID_FILE, i18n.t('file')],
  [PRODUCT_ID_PCBE, i18n.t('privateCloudBusinessEdition')],
  [PRODUCT_ID_SDS, i18n.t('softwareDefinedStorage')],
  [PRODUCT_ID_ALLETRAB10K, i18n.t('alletraMPB10k')],
]);
export const PRODUCT_ID_LIST = [...PRODUCT_NAMES.keys()];
export const MODEL_LIST_PCBE = [
  HPE_ALLETRA_DHCI,
  HPE_ALL_FLASH,
  HPE_HYBRID_FLASH,
];
export const MODEL_LIST_DIRECTATTACH_B10K = ['B10120', 'B10130', 'B10140'];
export const MODEL_LIST_SWITCHED_B10K = ['B10230', 'B10240'];
export const MODEL_LIST_NOCABLETRAY_SWITCHED_B10K = [
  'B10230 - No Cable Tray',
  'B10240 - No Cable Tray',
];
// Products with opt dropdown in model selection page
export const PRODUCTS_WITH_OPT = [
  PRODUCT_ID_ALLETRAB10K,
  PRODUCT_ID_ALLETRA9k,
  PRODUCT_ID_DHCI,
  PRODUCT_ID_PRIMERA,
];
export const DHCI_OPT_GREEN = 'green';
export const DHCI_OPT_BROWN = 'brown';
export const FLASH_OPT_GREEN = 'flashGreen';
export const FLASH_OPT_BROWN = 'flashBrown';
export const SIMPLIVITY_OPT_325GEN = '325 Gen10';
export const SIMPLIVITY_OPT_325GEN_PLUSV2 = '325 Gen10 Plus V2';
export const SIMPLIVITY_OPT_380GEN = '380 Gen10';
export const SIMPLIVITY_OPT_380GEN_PLUS = '380 Gen10 Plus';
export const NEW_ESXI_CLUSTER = 'New ESXi Cluster';
export const EXISTING_ESXI_CLUSTER = 'Existing ESXi Cluster';
export const SIMPLIVITY_OPT_325GEN11 = '325 Gen11';
export const SIMPLIVITY_OPT_380GEN11 = '380 Gen11';
export const HPE_VME = 'HPE VME';
export const VMWARE_ESXI = 'VMware ESXi';
export const FIELD_OPTIONS = [
  {
    lab: i18n.t('newEnvironment'),
    val: DHCI_OPT_GREEN,
  },
  {
    lab: i18n.t('existingEnvironment'),
    val: DHCI_OPT_BROWN,
  },
];
export const PCBE_FIELD_OPTIONS = [
  {
    lab: i18n.t('newEsxiCluster'),
    val: NEW_ESXI_CLUSTER,
  },
  {
    lab: i18n.t('existingEsxiCluster'),
    val: EXISTING_ESXI_CLUSTER,
  },
];
export const PCBE_INSTALLATION_OPTION = [
  {
    lab: 'Factory Integrated',
    val: DHCI_OPT_GREEN,
  },
  {
    lab: 'Field Integrated',
    val: DHCI_OPT_BROWN,
  },
];
export const PCBE_HYPERVISOR = [
  {
    lab: 'HPE VME',
    val: HPE_VME,
  },
  {
    lab: 'VMware ESXi',
    val: VMWARE_ESXI,
  },
];
export const SIMPLIVITY_MODEL_OPTIONS = [
  {
    lab: i18n.t('simplivityModelOPT325Gen'),
    val: SIMPLIVITY_OPT_325GEN,
  },
  {
    lab: i18n.t('simplivityModelOPT325GenPlusV2'),
    val: SIMPLIVITY_OPT_325GEN_PLUSV2,
  },
  {
    lab: i18n.t('simplivityModelOPT325Gen11'),
    val: SIMPLIVITY_OPT_325GEN11,
  },
  {
    lab: i18n.t('simplivityModelOPT380Gen'),
    val: SIMPLIVITY_OPT_380GEN,
  },
  {
    lab: i18n.t('simplivityModelOPT380GenPlus'),
    val: SIMPLIVITY_OPT_380GEN_PLUS,
  },
  {
    lab: i18n.t('simplivityModelOPT380Gen11'),
    val: SIMPLIVITY_OPT_380GEN11,
  },
];
export const DHCI_OPT_OPTIONS = fieldKeys(FIELD_OPTIONS);
export const PRIMERA_OPT_FIELD = 'field';
export const PRIMERA_OPT_FACTORY = 'factory';
export const ALLETRAMP_OPT_BLUETOOTH =
  'HPE Storage Connectivity App (Bluetooth method)';
export const ALLETRAMP_OPT_PHYSICAL_NETWORK =
  'HPE Cloud Connectivity Wizard/Discovery Tool';
export const OAAS_ClOUD_CONNECTION_APP =
  'HPE Storage Connectivity App (Bluetooth method) ';
export const OAAS_ClOUD_CONNECITVITY_WIZARD =
  'HPE Cloud Connectivity Wizard/Discovery Tool';
export const OAAS_ClOUD_CONNECT_CLI = 'HPE cloudconnect CLI';
export const STORAGE_PURCHASE_OPT_OWNED = 'owned';
export const STORAGE_PURCHASE_OPT_SUBSCRIBED = 'subscribed';
export const ALLETRAMP_OPT_DIRECT_ATTACHED = 'Direct Attached';
export const ALLETRAMP_OPT_SWITCHED = 'Switched';
export const ALLETRAMP_OPT_SWITCHED_NOCABLETRAY = 'Switched - No Cable Tray';
export const CABLETRAY_OPT_YES = 'Yes';
export const CABLETRAY_OPT_NO = 'No';
export const HPE_GREENLAKE_CLOUD_PLATFORM = 'HPE GreenLake Cloud Platform';
export const HPE_GREENLAKE_DEDICATED_PLATFORM =
  'HPE GreenLake Dedicated Platform';
export const SELECT_CABLETRAY = [
  {
    lab: 'Yes',
    val: CABLETRAY_OPT_YES,
  },
  {
    lab: 'No',
    val: CABLETRAY_OPT_NO,
  },
];
export const PRIMERA_CONFIGS = [
  {
    lab: 'Factory Integrated',
    val: PRIMERA_OPT_FACTORY,
  },
  {
    lab: 'Field Integrated',
    val: PRIMERA_OPT_FIELD,
  },
];
export const BAAS9K_OPT_OPTIONS = [
  {
    lab: 'Field Integrated',
    val: PRIMERA_OPT_FIELD,
  },
];
export const ALLETRAMP_CONFIGS = [
  {
    lab: 'HPE Storage Connectivity App (Bluetooth method)',
    val: ALLETRAMP_OPT_BLUETOOTH,
  },
  {
    lab: 'HPE Cloud Connectivity Wizard/Discovery Tool',
    val: ALLETRAMP_OPT_PHYSICAL_NETWORK,
  },
];
export const OAAS_CONFIGS = [
  {
    lab: 'HPE Storage Connectivity App (Bluetooth method)',
    val: OAAS_ClOUD_CONNECTION_APP,
  },
  {
    lab: 'HPE Cloud Connectivity Wizard/Discovery Tool',
    val: OAAS_ClOUD_CONNECITVITY_WIZARD,
  },
  {
    lab: 'HPE cloudconnect CLI',
    val: OAAS_ClOUD_CONNECT_CLI,
  },
];
export const ALLETRAMP_CONFIGURATION = [
  {
    lab: 'Direct Attached',
    val: ALLETRAMP_OPT_DIRECT_ATTACHED,
  },
  {
    lab: 'Switched',
    val: ALLETRAMP_OPT_SWITCHED,
  },
  {
    lab: 'Switched - No Cable Tray',
    val: ALLETRAMP_OPT_SWITCHED_NOCABLETRAY,
  },
];
export const STORAGE_PURCHASE_OPT = [
  {
    lab: 'Owned',
    val: STORAGE_PURCHASE_OPT_OWNED,
  },
  {
    lab: 'Subscribed',
    val: STORAGE_PURCHASE_OPT_SUBSCRIBED,
  },
];
export const STORAGE_PURCHASE_OPT_FILE = [
  {
    lab: 'Owned',
    val: STORAGE_PURCHASE_OPT_OWNED,
  },
];
export const GREENLAKE_PLATFORM_OPTIONS = [
  {
    lab: 'HPE GreenLake Cloud Platform',
    val: HPE_GREENLAKE_CLOUD_PLATFORM,
  },
  {
    lab: 'HPE GreenLake Dedicated Platform',
    val: HPE_GREENLAKE_DEDICATED_PLATFORM,
  },
];
export const PRIMERA_OPT_OPTIONS = fieldKeys(PRIMERA_CONFIGS);
export const ALLETRAMP_OPT_OPTIONS = fieldKeys(ALLETRAMP_CONFIGS);
export const OAAS_OPT_OPTIONS = fieldKeys(OAAS_CONFIGS);
export const STORAGE_PURCHASE_OPTIONS = fieldKeys(STORAGE_PURCHASE_OPT);
// Folders
export const ALLETRAMP_DOC_FOLDER_NAME = 'alletra_mp_files';
export const ALLETRA9k_DOC_FOLDER_NAME = 'minotaur_files';
export const ALLETRA6k_DOC_FOLDER_NAME = 'bluetail_files';
export const ALLETRA5k_DOC_FOLDER_NAME = 'alletra5K_files';
export const DHCI_ALLETRA6k_DOC_FOLDER_NAME = 'dHCI6K_files';
export const BAAS_6K_B_DOC_FOLDER_NAME = 'baas_6K_business_files';
export const BAAS_9K_M_DOC_FOLDER_NAME = 'baas_9K_mission_files';

export const INSTALLATION_GUIDE_URL = {
  [PRODUCT_ID_NIMBLE]:
    'https://infosight.hpe.com/InfoSight/media/cms/active/public/pubs_Installation_Guide_WC.pdf',
  [PRODUCT_ID_DHCI]: {
    [DHCI_OPT_BROWN]:
      'https://infosight.hpe.com/InfoSight/media/cms/active/public/pubs_HPE_Nimble_Storage_dHCI_Deployment_Guide_for_Existing_Installations_6_0_x.pdf',
    [DHCI_OPT_GREEN]:
      'https://infosight.hpe.com/InfoSight/media/cms/active/public/pubs_HPE_Nimble_Storage_dHCI_Deployment_Guide_for_New_Installations_6_0_x.pdf',
  },
  [PRODUCT_ID_PCBE]: {
    [DHCI_OPT_BROWN]:
      'https://support.hpe.com/hpesc/docDisplay?docId=sd00006334en_us',
    [DHCI_OPT_GREEN]:
      'https://support.hpe.com/hpesc/docDisplay?docId=sd00006334en_us',
    [FLASH_OPT_BROWN]:
      'https://infosight.hpe.com/InfoSight/media/cms/active/public/pubs_HPE_Alletra_dHCI_Deployment_Guide_for_Existing_Installations_on_Array_OS_6_1_x_and_Later_6_1_x.pdf',
    [FLASH_OPT_GREEN]:
      'https://infosight.hpe.com/InfoSight/media/cms/active/public/pubs_HPE_Alletra_dHCI_Deployment_Guide_for_New_Installations_on_Array_OS_6_1_x_and_Later_6_1_x.pdf',
    [SIMPLIVITY_OPT_325GEN]:
      'https://internal.support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00119820en_us',
    [SIMPLIVITY_OPT_325GEN_PLUSV2]:
      'https://internal.support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00119820en_us',
    [SIMPLIVITY_OPT_380GEN]:
      'https://internal.support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00059523en_us',
    [SIMPLIVITY_OPT_380GEN_PLUS]:
      'https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00131393en_us',
    [SIMPLIVITY_OPT_325GEN11]:
      'https://support.hpe.com/hpesc/public/docDisplay?docId=dp00003979en_us&docLocale=en_US',
    [SIMPLIVITY_OPT_380GEN11]:
      'https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=dp00003980en_us',
  },
  [PRODUCT_ID_DHCI_ALLETRA6K]: {
    [DHCI_OPT_BROWN]:
      'https://support.hpe.com/hpesc/public/docDisplay?docId=dp00004458en_us&docLocale=en_US',
    [DHCI_OPT_GREEN]:
      'https://support.hpe.com/hpesc/public/docDisplay?docId=dp00004459en_us&docLocale=en_US',
  },
  [PRODUCT_ID_PRIMERA]: {
    [PRIMERA_OPT_FACTORY]:
      'https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=sd00001308en_us',
    [PRIMERA_OPT_FIELD]:
      'https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00088909en_us',
  },
  [PRODUCT_ID_ALLETRA9k]: {
    [PRIMERA_OPT_FACTORY]:
      'https://internal.support.hpe.com/hpesc/public/docDisplay?docId=a00113710en_us&docLocale=en_US',
    [PRIMERA_OPT_FIELD]:
      'https://internal.support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00113712en_us',
  },
  [PRODUCT_ID_ALLETRAB10K]: {
    [PRIMERA_OPT_FACTORY]:
      'https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=sd00002405en_us',
    [PRIMERA_OPT_FIELD]:
      'https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=sd00002407en_us',
  },
  [PRODUCT_ID_ALLETRA6k]:
    'https://internal.support.hpe.com/hpesc/public/docDisplay?docId=dp00006027en_us',
  [PRODUCT_ID_ALLETRA5k]:
    'https://support.hpe.com/hpesc/public/docDisplay?docId=dp00006025en_us',
  [PRODUCT_ID_BAAS_5K_G]:
    'https://internal.support.hpe.com/hpesc/public/docDisplay?docId=dp00006025en_us',
  [PRODUCT_ID_BAAS_6K_B]:
    'https://internal.support.hpe.com/hpesc/public/docDisplay?docId=dp00006027en_us',
  [PRODUCT_ID_BAAS_9K_M]:
    'https://internal.support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00113712en_us',
  [PRODUCT_ID_OAAS]:
    'http://www.hpe.com/support/AlletraMPX10000-install-config-field',
};

export const INSTALLATION_GUIDE_LABEL = {
  [PRODUCT_ID_NIMBLE]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_DHCI]: i18n.t('downloadDeploymentGuide'),
  [PRODUCT_ID_DHCI_ALLETRA6K]: i18n.t('downloadDeploymentGuide'),
  [PRODUCT_ID_PRIMERA]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_ALLETRAB10K]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_ALLETRA9k]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_ALLETRA6k]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_ALLETRA5k]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_BAAS_5K_G]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_BAAS_6K_B]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_BAAS_9K_M]: i18n.t('downloadInstallGuide'),
  [PRODUCT_ID_PCBE]: i18n.t('downloadDeploymentGuide'),
  [PRODUCT_ID_SDS]: i18n.t('downloadDeploymentGuide'),
  [PRODUCT_ID_OAAS]: i18n.t('downloadInstallGuide'),
};

export const TAKE_SURVEY_LINK =
  'https://forms.office.com/Pages/ResponsePage.aspx?id=YSBbEGm2MUuSrCTTBNGV3IyiSL-XNIVNpBiV6crVMspUOEVFQk45RjlQMlBHTlZZMUFaQTlRS09OQy4u';
